import { useMutation, useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { downloadOneDriverDeliveriesReport } from "../../helpers";
import { requestGetDeliveriesByDriver } from "./getDeliveriesByDriver.request";
import {
  GetDeliveriesByDriverRequestParams,
  GetDeliveriesByDriverResponse
} from "./getDeliveriesByDriver.types";

const useGetDeliveriesByDriver = (
  requestParams: GetDeliveriesByDriverRequestParams,
  options?: QueryOptions<
    GetDeliveriesByDriverResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["driver", "admin", "with-deliveries", requestParams],
    queryFn: async () => await requestGetDeliveriesByDriver(requestParams),
    keepPreviousData: true,
    onError: toastServerError,
    ...options
  });

  const allPagesDeliveries = useMutation({
    mutationFn: async () =>
      await requestGetDeliveriesByDriver({ ...requestParams, take: 2000 }),
    onSuccess: (response) =>
      downloadOneDriverDeliveriesReport({
        driver: response.data.driver,
        deliveries: response.data.deliveries,
        dateRange: {
          from: requestParams.from,
          to: requestParams.to
        }
      }),
    onError: toastServerError
  });

  return {
    driver: data?.data.driver,
    deliveries: data?.data.deliveries,
    allPagesDeliveries,
    meta: data?.meta,
    ...rest
  };
};

export default useGetDeliveriesByDriver;
